<template>
  <b-modal
    :title="`Anular Expediente ${canceledFile.numero}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <div class="">
      Para anular el expediente debes realizarlo
       bajo la seguridad del 2FA o Cód. de verificación
    </div>
    <div class="wrap-option">
      <vs-radio v-model="cancel.typeCancel" vs-value="twoFa">2FA (OTP)</vs-radio>
      <vs-radio
        data-cy="Verification-code"
        v-model="cancel.typeCancel"
        vs-value="internCode"
      >
        Código de Verificación
      </vs-radio>
    </div>
    <div v-if="cancel.typeCancel === 'internCode'" class="wrap-form">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            data-cy="request-code"
            size="small"
            :disabled="gettingCode"
            color="primary"
            v-on:click="getCode()"
          >
            Solicitar código
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-input
            data-cy="write-verification-code"
            oninput="javascript: if (this.value.length > this.maxLength)
              this.value = this.value.slice(0, this.maxLength);"
            maxlength = "8"
            label="Código de Verificación"
            v-model="cancel.code"
          />
        </vs-col>
      </vs-row>
    </div>
    <div v-if="cancel.typeCancel === 'twoFa'" class="wrap-form">
      <vs-input
        oninput="javascript: if (this.value.length > this.maxLength)
          this.value = this.value.slice(0, this.maxLength);"
        maxlength = "8"
        label="Código de Verificación"
        v-model="cancel.code"
      />
    </div>
    <div class="wrap-commentary">
      <p class="comment-text">*Los saltos de línea serán removidos</p>
      <vs-textarea
        data-cy="write-comment"
        maxlength="255"
        label="Comentario"
        v-model="comment"
      />
      <div v-if="notValid">
        <small style="color: red;">
          No has ingresado un comentario para validar esta acción
        </small>
      </div>
    </div>
    <div style="margin-top: 20px;text-align: center">
      <vs-button
        data-cy="cancel-file"
        color="primary"
        type="border"
        v-on:click="cancelFile()"
      >
        Anular Expediente
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltersDntMixin from '@/febos/chile/dnt/mixins/FiltersDntMixin';

export default {
  mixins: [FiltersDntMixin],
  name: 'PopUpCancelFile',
  props: {
    canceledFile: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      gettingCode: false,
      comment: '',
      notValid: false,
      cancel: {
        typeCancel: 'internCode'
      }
    };
  },
  watch: {
    comment() {
      this.notValid = false;
    },
    canceledFile() {
      this.notValid = false;
      this.comment = '';
      this.cancel.code = '';
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'verificationCode',
      'loading'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'cancelFile';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'attemptCancelFile',
      'listDocuments'
    ]),
    ...mapActions('Usuario', [
      'getVerificationCode'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async cancelFile() {
      this.notValid = false;
      if (this.comment === '') {
        this.notValid = true;
        return;
      }

      const cancel = {
        febosId: this.canceledFile.febosId
      };

      if (this.cancel.typeCancel === 'internCode') {
        cancel.codigo = this.cancel.code;
        cancel.idExterno = this.verificationCode;
      } else {
        cancel.otp = this.cancel.code;
      }
      this.comment = this.comment.replace(/(\r\n|\n|\r)/gm, ' ');
      cancel.comentario = this.comment;
      await this.attemptCancelFile(cancel);
    },
    async getCode() {
      this.gettingCode = true;
      await this.getVerificationCode(
        { motivo: `Verificación para anular expediente Nº: ${this.canceledFile.numero}` }
      );
      this.$bvToast.toast(
        'El código de verificación llegará en unos instantes a tu correo',
        {
          title: '¡Hey!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
      this.gettingCode = false;
    },
  }
};
</script>
<style scoped>

.wrap-option {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.wrap-form {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}

.comment-text{
  font-size: 12px;
  margin-bottom: 10px;
}
</style>
